
<script>
import { mapGetters } from 'vuex';
import bowser from 'bowser';
import CheckBrowser from './views/main/catalog/components/check-browser';
import CookieConsent from './views/main/catalog/components/cookie-consent';
import PlatformMarker from '@agrial/platform-marker';

export default {
  name: 'App',
  components: {
    CheckBrowser, CookieConsent, PlatformMarker
  },
  computed: {
    ...mapGetters({
      showLoader: 'navigation/pending'
    }),
    /**
    * Retourne true si le navigateur utilisé à une version inférieure.
    */
    isBrowserCompatible () {
      const browser = bowser.getParser(window.navigator.userAgent);
      return browser.satisfies({
        chrome: '>=63',
        safari: '>=11.1',
        firefox: '>=67',
        edge: '>=79',
        opera: '>=50',
        samsungBrowser: '>=8.2',
        ios: '>=11.3'
      });
    },
    env () {
      return process.env.NODE_ENV.replace('development', 'dev');
    }
  }
};
</script>

<template>
  <v-app
    id="app"
    data-app
    class="screen-size"
  >
    <PlatformMarker :platform="env" />
    <Loader v-if="showLoader" />
    <CookieConsent />
    <CheckBrowser v-if="!isBrowserCompatible" />
    <router-view v-else />
  </v-app>
</template>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i");

#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  overflow-y: scroll;
   overflow-x: hidden;
}
</style>
